export enum EAction {
  CREATE = "create",
  READ = "read",
  UPDATE = "update",
  DELETE = "delete",
}

export enum IdlingFeeType {
  FIXED = "fixed",
  PER_MINUTE = "per-minute",
}

export enum RewardStatus {
  NEW = 'new',
  REDEEMED = 'redeemed',
  USED = 'used',
  EXPIRED = 'expired',
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  PENDING = 'pending',
}

export enum RewardProgramStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  ENDED = 'ended',
}

export enum RewardType {
  MYSTERY_BOX = 'mystery_box',
  SIGN_IN_BONUS = 'sign_in_bonus',
  PRODUCTS = 'products',
  REFERRAL = 'referral',
}

export enum RewardProgramType {
  POINTS = 'points',
  GIFT = 'gift',
  VOUCHER = 'voucher',
  CASH_BACK = 'cashback',
  PRODUCT = 'product',
}

export enum RedeemBy {
  CHARGE_SESSION = "charge_session",
  POINT = "point",
}

